import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification, Radio} from 'antd';

import {addDiscountReason} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddDiscountReasonForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addDiscountReason({...values});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Discount Reason">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Default Rate"
          >
            {getFieldDecorator('defaultRate', {
              initialValue: 0,
              rules: [{
                required: true,
                message: 'Default rate is required'
              }]
            })(
              <InputNumber precision={2} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Default Rate Type"
          >
            {getFieldDecorator('defaultRateType', {
              initialValue: 'percentage',
              rules: [{
                required: true,
                message: 'Default rate type is required'
              }]
            })(
              <Radio.Group>
                <Radio.Button value="percentage">%</Radio.Button>
                <Radio.Button value="flat">$</Radio.Button>
              </Radio.Group>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Discount Reason
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddDiscountReasonForm.propTypes = {
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  addDiscountReason: PropTypes.func.isRequired
};

const AddDiscountReasonPage = Form.create()(AddDiscountReasonForm);

const mapStateToProps = state => ({
  loading: state.discountReason.addingDiscountReason,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  addDiscountReason
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddDiscountReasonPage);



// WEBPACK FOOTER //
// ./src/DiscountReason/AddDiscountReasonPage.js